import { Routes, Route } from "react-router-dom";
import Maps from "./Maps";

const index = () => {
	return (
		<Routes>
			<Route index element={<Maps />} />
		</Routes>
	);
};

export default index;
